module.exports = __webpack_public_path__ + "static/img/honor12.5345bf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor12.png
// module id = b2ij
// module chunks = 0